import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "antd";
import styled from "styled-components";

import { SupportEmail } from "../../../PatientApplications/enrollTab/utils/components";
import { GRAY_500 } from "../../../../../constant/colors";
import { fontWeights } from "../../../../../constant/styles";

const { Text } = Typography;

export const TextStyled = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  color: ${GRAY_500};
  margin-bottom: 10px;
`;

// Shared "failure reason" header used by the enroll failure result screens
// (EnrollGeneralFailure / EnrollBmsCopayLsFailure).
export const EnrollFailureHeader = ({ error }) => {
  const { t } = useTranslation();

  return (
    <TextStyled>
      <span style={{ fontWeight: fontWeights.semibold, textAlign: "center" }}>
        {t("patientApplications.enroll.enroll_result.failure_reason")}
        {error}
      </span>
    </TextStyled>
  );
};

// Shared support-contact footer used by the enroll failure result screens.
// The lead-in copy differs per flow, so callers pass it as children.
export const EnrollFailureSupportFooter = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginTop: "40px", display: "inlineBlock" }}>
      {children}
      <SupportEmail />
      <TextStyled>{t("patientApplications.enroll.enroll_result.dont_forget_to_include_error")}</TextStyled>
    </div>
  );
};
